fragment MovingFullWidthImagesFragment on movingFullWidthImages_Entry {
  typeHandle
  heading
  claim
  body
  cta {
    ...LinkFragment
  }
  slides {
    ... on movingSlidesBlock_Entry {
      id
      image {
        url
      }
      alt
    }
  }
}
